import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Divider } from 'antd';

import { membershipData } from './';

const CollateralMemberColumn = ({ type }) => {
    const currentMembershipData = membershipData[type];
    const renderFooterDescription = () => {
        switch (type) {
            case 'tier':
                return (
                    <div className="footer-description">
                        *Using the HollaEx kit exchange software is free for everybody to deploy and host themselves. For those that require help with hosting a <Link to="/hosting">cloud plan</Link> is available.
                    </div>
                );
            case 'lite':
                return (
                    <div>
                        <div className="footer-description">
                            *Profit margins are dependent on fees set by exchange operator. The lowest allowed trading fees that can be set for Holla member is 5 bps for maker and 10 bps for taker.
                        </div>
                        <div className="footer-description">
                            All <Link to="/hosting">cloud</Link> solutions fall under XHT1 Lite Membership level
                        </div>
                    </div>
                );
            case 'holla':
            default:
                return (
                    <div className="footer-description">
                        *Profit margins are dependent on fees set by exchange operator. The lowest allowed trading fees that can be set for Holla member is -2.5 bps for maker and 5 bps for taker.
                    </div>
                );
        }
    }
    const renderImgDescription = (value) => {
        switch (value) {
            case 'tier':
                return (
                    <Fragment>
                        <div className="tier-img-title">XHT-0</div>
                        <div className="tier-img-description">Tier 0 member</div>
                    </Fragment>
                );
            case 'lite':
                return (
                    <Fragment>
                        <div className="tier-img-title">XHT-1</div>
                        <div className="tier-img-description">Lite member</div>
                    </Fragment>
                );
            case 'holla':
            default:
                return (
                    <Fragment>
                        <div className="tier-img-title">XHT-2</div>
                        <div className="tier-img-description">HollaEx member</div>
                    </Fragment>
                );
        }
    };

    return (
        <div className="content">
            <div className="membership-container">
                <div className="center-wrapper">
                    <div className="member-tier-head">
                        <h3>
                            {currentMembershipData.title}
                        </h3>
                        <div className="small-text sub-title">
                            {currentMembershipData.description_1}
                        </div>
                        <div className="small-text sub-title">
                            {currentMembershipData.description_2}
                        </div>
                    </div>
                    <div className={`member-tier-img member-img-${type}`}>
                        {renderImgDescription(type)}
                    </div>
                    <div className="inner-content">
                        {currentMembershipData.section.map((subContent, index) => {
                            return (
                                <div key={index}>
                                    <div>
                                        <div className="sub-header">
                                            {subContent.title}
                                        </div>
                                        <ul className="small-text">
                                            <li>{subContent.smallDescription}</li>
                                        </ul>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="footer-content">
                    <Divider />
                    <div className="stake-wrapper">
                        <div className="stake-label">{currentMembershipData.footer.title}</div>
                        <div className="small-description">{currentMembershipData.footer.smallDescription}</div>
                    </div>
                    {renderFooterDescription()}
                </div>
            </div>
        </div>
    )
}

export default CollateralMemberColumn;
